import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bcdaab12"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Szállás igény részletei", -1))
const _hoisted_2 = {
  class: "d-flex align-center flex-wrap",
  style: {"gap":"12px"}
}
const _hoisted_3 = { class: "flex-grow-1" }
const _hoisted_4 = { class: "text-subtitle-1 font-weight-bold" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, " A piszkozatok kiválasztásával vagy az \"Összes elküldése\" gombbal teheti őket láthatóvá az ügyfél számára. ", -1))
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "pl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_AdminOfferTable = _resolveComponent("AdminOfferTable")!
  const _component_CreateOffer = _resolveComponent("CreateOffer")!
  const _component_CreateBooking = _resolveComponent("CreateBooking")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                  default: _withCtx(() => [
                    _hoisted_1,
                    _createVNode(_component_v_spacer),
                    (!_ctx.canEdit)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props: tooltipProps }) => [
                            _createElementVNode("span", _normalizeProps(_guardReactiveProps(tooltipProps)), [
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                variant: "text",
                                size: "small",
                                "prepend-icon": "mdi-pencil",
                                disabled: true
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Módosítás ")
                                ]),
                                _: 1
                              })
                            ], 16)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.editBlockedReason), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          color: "primary",
                          variant: "text",
                          size: "small",
                          "prepend-icon": "mdi-pencil",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('editInquiry')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Módosítás ")
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              "model-value": 
                  _ctx.formatPublicReference(
                    _ctx.props.accommodationInquiry.publicReference
                  )
                ,
                              label: "Referencia",
                              variant: "outlined",
                              readonly: ""
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              "model-value": _ctx.props.accommodationInquiry.costCenterName,
                              label: "Költséghely",
                              variant: "outlined",
                              readonly: ""
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { sm: "4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.props.accommodationInquiry.area,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.props.accommodationInquiry.area) = $event)),
                              label: "Helység",
                              variant: "outlined",
                              readonly: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { sm: "4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.props.accommodationInquiry.numberOfPeople,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.props.accommodationInquiry.numberOfPeople) = $event)),
                              label: "Létszám",
                              variant: "outlined",
                              readonly: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { sm: "4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              label: "Státusz",
                              variant: "outlined",
                              modelValue: _ctx.props.accommodationInquiry.status,
                              "onUpdate:modelValue": [
                                _cache[3] || (_cache[3] = ($event: any) => ((_ctx.props.accommodationInquiry.status) = $event)),
                                _ctx.handleStatusChange
                              ],
                              items: _ctx.inquiryStatusOptions,
                              "item-title": "label",
                              "item-value": "value"
                            }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.props.accommodationInquiry.from,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.props.accommodationInquiry.from) = $event)),
                              label: "Érkezés",
                              variant: "outlined",
                              readonly: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.props.accommodationInquiry.to,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.props.accommodationInquiry.to) = $event)),
                              label: "Távozás",
                              variant: "outlined",
                              readonly: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              "model-value": 
                  _ctx.placementTypeLabel(_ctx.props.accommodationInquiry.placementType)
                ,
                              label: "Elhelyezés",
                              variant: "outlined",
                              readonly: ""
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.props.accommodationInquiry.contactName,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.props.accommodationInquiry.contactName) = $event)),
                              label: "Kapcsolattartó neve",
                              variant: "outlined",
                              readonly: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.props.accommodationInquiry.contactPhone,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.props.accommodationInquiry.contactPhone) = $event)),
                              label: "Kapcsolattartó telefonszáma",
                              variant: "outlined",
                              readonly: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_textarea, {
                              modelValue: _ctx.props.accommodationInquiry.catering,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.props.accommodationInquiry.catering) = $event)),
                              label: "Ellátás",
                              variant: "outlined",
                              rows: "2",
                              readonly: "",
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_textarea, {
                              modelValue: _ctx.props.accommodationInquiry.comment,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.props.accommodationInquiry.comment) = $event)),
                              label: "Komment",
                              variant: "outlined",
                              rows: "2",
                              readonly: "",
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "8"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "offers-card" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" Ajánlatok ")
                  ]),
                  _: 1
                }),
                (_ctx.draftOffers.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      type: "warning",
                      variant: "tonal",
                      class: "ma-4 draft-summary-alert",
                      border: "start",
                      prominent: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, " ⚠ " + _toDisplayString(_ctx.draftOffers.length) + " olyan ajánlat van, amit az ügyfél MÉG NEM LÁT ", 1),
                            _hoisted_5
                          ]),
                          _createVNode(_component_v_btn, {
                            color: "warning",
                            variant: "flat",
                            disabled: _ctx.selectedDraftIds.size === 0 || _ctx.publishing,
                            loading: _ctx.publishing,
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openBulkPublishConfirm('selected')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Kiválasztottak elküldése (" + _toDisplayString(_ctx.selectedDraftIds.size) + ") ", 1)
                            ]),
                            _: 1
                          }, 8, ["disabled", "loading"]),
                          _createVNode(_component_v_btn, {
                            color: "warning",
                            variant: "outlined",
                            disabled: _ctx.publishing,
                            loading: _ctx.publishing,
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openBulkPublishConfirm('all')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Összes elküldése ")
                            ]),
                            _: 1
                          }, 8, ["disabled", "loading"])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.props.accommodationInquiry.offerEntities.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_container, { key: 1 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.accommodationInquiry.offerEntities, (offer) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: offer.id
                          }, [
                            _createVNode(_component_AdminOfferTable, {
                              offer: offer,
                              "can-accept": !_ctx.hasAcceptedOffer && offer.status !== 'DRAFT',
                              selected: _ctx.selectedDraftIds.has(offer.id),
                              "onUpdate:selected": (v) => _ctx.toggleDraftSelection(offer.id, v),
                              onAcceptOffer: _ctx.acceptOffer,
                              onPublishOffer: _ctx.publishSingleOffer,
                              onEditOffer: _ctx.editDraftOffer,
                              onDeleteOffer: _ctx.deleteDraftOffer
                            }, null, 8, ["offer", "can-accept", "selected", "onUpdate:selected", "onAcceptOffer", "onPublishOffer", "onEditOffer", "onDeleteOffer"])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_container, { key: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Még nincsenek ajánlatok ")
                      ]),
                      _: 1
                    })),
                _createVNode(_component_v_card_actions, { class: "pa-4" }, {
                  default: _withCtx(() => [
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createBlock(_component_CreateOffer, {
                          key: 0,
                          ref: "createOfferRef",
                          inquiryId: _ctx.inquiryId,
                          inquiry: _ctx.props.accommodationInquiry,
                          from: _ctx.props.accommodationInquiry.from,
                          to: _ctx.props.accommodationInquiry.to,
                          numberOfPeople: _ctx.props.accommodationInquiry.numberOfPeople,
                          onOfferCreated: _ctx.onOfferCreated
                        }, null, 8, ["inquiryId", "inquiry", "from", "to", "numberOfPeople", "onOfferCreated"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_spacer),
                    (!_ctx.hasBooking)
                      ? (_openBlock(), _createBlock(_component_CreateBooking, {
                          key: 1,
                          accommodationInquiry: _ctx.props.accommodationInquiry
                        }, null, 8, ["accommodationInquiry"]))
                      : (_openBlock(), _createBlock(_component_v_btn, {
                          key: 2,
                          color: "primary",
                          to: `/admin/bookings/${_ctx.props.accommodationInquiry.publicReference}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Tovább a foglaláshoz ")
                          ]),
                          _: 1
                        }, 8, ["to"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showBulkPublishConfirm,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showBulkPublishConfirm) = $event)),
      "max-width": "520"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Ajánlatok küldése az ügyfélnek")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_6, " Az alábbi " + _toDisplayString(_ctx.pendingPublishOffers.length) + " ajánlat ezzel láthatóvá válik az ügyfél számára: ", 1),
                _createElementVNode("ul", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingPublishOffers, (offer) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: offer.id,
                      class: "text-body-2"
                    }, _toDisplayString(offer.items[0]?.accommodation || "—") + " (" + _toDisplayString(offer.items.length) + " tétel) ", 1))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  text: "",
                  color: "grey",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showBulkPublishConfirm = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Mégse")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "warning",
                  variant: "flat",
                  onClick: _ctx.confirmBulkPublish
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Igen, küldés")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}